import printJS from 'print-js';

export const usePdfPrint = () => {
  const printPdf = (pdfData: string, documentTitle: string = 'document.pdf') => {
    try {
      // Create a binary blob from the base64 data
      const binaryString = atob(pdfData);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create a blob and URL for printing
      const blob = new Blob([bytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      printJS({
        printable: url,
        type: 'pdf',
        documentTitle,
        onLoadingEnd: () => {
          URL.revokeObjectURL(url);
        },
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error printing PDF:', error);
    }
  };

  return { printPdf };
};
